import { Component, OnInit } from '@angular/core';
import { MdInputModule, MdDialog, MdDialogRef} from '@angular/material';
import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
@Component({
    templateUrl: 'administer-vaccine-popup.html'
})

export class AdministerVaccinePopupComponent implements OnInit {
    constructor(public baseService: BaseService,
        public dialogService: DialogService,
        public dialogRef: MdDialogRef<AdministerVaccinePopupComponent>,
      ) {}
    public isSuccess = false;

    ngOnInit() {
    }

    onCloseDialog() {
        this.dialogRef.close(this.isSuccess);
    }
    
    onSubmit() {
        this.isSuccess = true;
        this.onCloseDialog();
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/administer-vaccine/administer-vaccine-popup.component.ts